import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../components/_molecules/Modal/Modal';
import Button from '../../../components/_atomic/Button/Button';
import './SuccessModal.scss';


const propTypes = {
  visible: PropTypes.bool.isRequired,
  buttonClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};


const SuccessModal = ({ visible, buttonClick, text }) => (
  <Modal className="media-success-modal" visible={visible}>
    <div className="main-label-no-transform">
      <span> Success!</span>
    </div>
    <div className="main-text">
      <span>{text}</span>
    </div>
    <div className="button-wrapper">
      <Button label="Ok" clickHandler={buttonClick} />
    </div>
  </Modal>
);


SuccessModal.propTypes = propTypes;


export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/_molecules/SuccessModal/SuccessModal.js